import i18n from "../language";
import store from '../store/store'

export const personHistoryGridColumns = [
    {
        field: 'id',
        filterable: false,
        width: 100,
        hidden: true,
        lockable: false,
        locked: false,
        title: i18n.t('person.gridHeaders.id'),
    },
    {
        field: 'firstName',
        width: 200,
        lockable: true,
        locked: false,
        title: i18n.t('person.gridHeaders.firstName'),
    },
    {
        field: 'middleName',
        width: 200,
        lockable: true,
        locked: false,
        title: i18n.t('person.gridHeaders.middleName'),
    },
    {
        field: 'lastName',
        width: 200,
        lockable: true,
        locked: false,
        title: i18n.t('person.gridHeaders.lastName'),
    },
    {
        field: 'email',
        width: 200,
        lockable: true,
        locked: false,
        title: i18n.t('person.gridHeaders.email'),
    },
    {
        field: 'phone',
        width: 200,
        lockable: true,
        locked: false,
        hidden: true,
        title: i18n.t('person.phone'),
    },
    {
        field: 'mobilePhone',
        width: 200,
        lockable: true,
        locked: false,
        title: i18n.t('person.mobilePhone'),
    },
    {
        field: 'personIdentificationId',
        width: 100,
        lockable: true,
        locked: false,
        hidden: true,
        title: 'Person Identification Id',
    },
    {
        field: 'identificationTypeId',
        width: 100,
        lockable: true,
        locked: false,
        hidden: true,
        title: 'Identification Type Id',
    },
    {
        field: 'identificationType',
        width: 150,
        lockable: true,
        locked: false,
        hidden: store.getters.isEnVersion,
        title: i18n.t('person.gridHeaders.identificationType'),
    },
    {
        field: 'identificationTypeEn',
        width: 150,
        lockable: true,
        locked: false,
        hidden: !store.getters.isEnVersion,
        title: i18n.t('person.gridHeaders.identificationType'),
    },
    {
        field: 'Number',
        width: 150,
        lockable: true,
        locked: false,
        title: i18n.t('person.identification'),
    },
    {
        field: 'genderType',
        width: 150,
        lockable: true,
        locked: false,
        hidden: store.getters.isEnVersion,
        title: i18n.t('person.gender'),
    },
    {
        field: 'genderTypeEn',
        width: 150,
        lockable: true,
        locked: false,
        hidden: !store.getters.isEnVersion,
        title: i18n.t('person.gender'),
    },
    {
        field: 'description',
        width: 200,
        lockable: true,
        locked: false,
        hidden: true,
        title: i18n.t('person.description'),
    },
    {
        field: 'position',
        width: 200,
        lockable: true,
        locked: false,
        hidden: store.getters.isEnVersion,
        title: i18n.t('person.position'),
    },
    {
        field: 'positionEn',
        width: 200,
        lockable: true,
        locked: false,
        hidden: !store.getters.isEnVersion,
        title: i18n.t('person.position'),
    },
    {
        field: 'positionStatistic',
        width: 200,
        lockable: true,
        locked: false,
        hidden: store.getters.isEnVersion,
        title: i18n.t('person.positionStatistic'),
    },
    {
        field: 'positionStatisticEn',
        width: 200,
        lockable: true,
        locked: false,
        hidden: !store.getters.isEnVersion,
        title: i18n.t('person.positionStatistic'),
    },
    {
        field: 'positionStr',
        width: 200,
        lockable: true,
        locked: false,
        hidden: true,
        title: i18n.t('person.position'),
    },
    {
        field: 'titleDegree',
        width: 200,
        lockable: true,
        locked: false,
        hidden: store.getters.isEnVersion,
        title: i18n.t('person.titleDegree'),
    },
    {
        field: 'titleDegreeEn',
        width: 200,
        lockable: true,
        locked: false,
        hidden: !store.getters.isEnVersion,
        title: i18n.t('person.titleDegree'),
    },
    {
        field: 'educationDegree',
        width: 200,
        lockable: true,
        locked: false,
        hidden: store.getters.isEnVersion,
        title: i18n.t('person.educationDegree'),
    },
    {
        field: 'educationDegreeEn',
        width: 200,
        lockable: true,
        locked: false,
        hidden: !store.getters.isEnVersion,
        title: i18n.t('person.educationDegree'),
    },
    {
        field: 'salutation',
        width: 200,
        lockable: true,
        locked: false,
        hidden: store.getters.isEnVersion,
        title: i18n.t('person.salutation'),
    },
    {
        field: 'salutationEn',
        width: 200,
        lockable: true,
        locked: false,
        hidden: !store.getters.isEnVersion,
        title: i18n.t('person.salutation'),
    },
    {
        field: 'updatedBy',
        width: 200,
        lockable: true,
        locked: false,
        hidden: false,
        title: i18n.t('person.gridHeaders.updatedBy'),
    },
    {
        field: 'updatedAt',
        width: 200,
        lockable: true,
        locked: false,
        hidden: false,
        format: '{0:dd.MM.yyyy HH:mm:ss}',
        title: i18n.t('person.gridHeaders.updatedAtUtc')
    },
]

export const personHistoryGridSchemaModelFields = {
    id: { name: 'id', type: 'number', editable: false, nullable: false, visible: true },
    firstName: { name: 'firstName', type: 'string', editable: false, nullable: true, visible: true },
    middleName: { name: 'middleName', type: 'string', editable: false, nullable: true, visible: true },
    lastName: { name: 'lastName', type: 'string', editable: false, nullable: true, visible: true },
    fullName: { name: 'fullName', type: 'string', editable: false, nullable: true, visible: true },
    fullNameEn: { name: 'fullNameEn', type: 'string', editable: false, nullable: true, visible: true },
    shortFullName: { name: 'shortFullName', type: 'string', editable: false, nullable: true, visible: true },
    shortFullNameEn: { name: 'shortFullNameEn', type: 'string', editable: false, nullable: true, visible: true },
    phone: { name: 'phone', type: 'string', editable: false, nullable: true, visible: true },
    mobilePhone: { name: 'mobilePhone', type: 'string', editable: false, nullable: true, visible: true },
    email: { name: 'email', type: 'string', editable: false, nullable: true, visible: true },
    personIdentificationId: { name: 'personIdentificationId', type: 'number', editable: false, nullable: true, visible: true },
    identificationTypeId: { name: 'identificationTypeId', type: 'number', editable: false, nullable: true, visible: true },
    identificationType: { name: 'identificationType', type: 'string', editable: false, nullable: true, visible: true },
    identificationTypeEn: { name: 'identificationTypeEn', type: 'string', editable: false, nullable: true, visible: true },
    number: { name: 'number', type: 'string', editable: false, nullable: true, visible: true },
    description: { name: 'description', type: 'string', editable: false, nullable: true, visible: true },
    genderType: { name: 'genderType', type: 'string', editable: false, nullable: true, visible: true },
    genderTypeEn: { name: 'genderTypeEn', type: 'string', editable: false, nullable: true, visible: true },
    position: { name: 'position', type: 'string', editable: false, nullable: true, visible: true },
    positionEn: { name: 'positionEn', type: 'string', editable: false, nullable: true, visible: true },
    positionStatistic: { name: 'positionStatistic', type: 'string', editable: false, nullable: true, visible: true },
    positionStatisticEn: { name: 'positionStatisticEn', type: 'string', editable: false, nullable: true, visible: true },
    positionStr: { name: 'positionStr', type: 'string', editable: false, nullable: true, visible: true },
    userId: { name: 'userId', type: 'string', editable: false, nullable: true, visible: true },
    educationDegree: { name: 'educationDegree', type: 'string', editable: false, nullable: true, visible: true },
    educationDegreeEn: { name: 'educationDegreeEn', type: 'string', editable: false, nullable: true, visible: true },
    titleDegree: { name: 'titleDegree', type: 'string', editable: false, nullable: true, visible: true },
    titleDegreeEn: { name: 'titleDegreeEn', type: 'string', editable: false, nullable: true, visible: true },
    salutation: { name: 'salutation', type: 'string', editable: false, nullable: true, visible: true },
    salutationEn: { name: 'salutationEn', type: 'string', editable: false, nullable: true, visible: true },
    parentId: { name: 'parentId', type: 'number', editable: false, nullable: true, visible: true },
    updatedBy: { name: 'updatedBy', type: 'string', editable: false, nullable: true, visible: true },
    updatedAt: { name: 'updatedAt', type: 'date', editable: false, nullable: true, visible: true },
    personSysStartTimeUtc: { name: 'personSysStartTimeUtc', type: 'date', editable: false, nullable: true, visible: true },
    personSysEndTimeUtc: { name: 'personSysEndTimeUtc', type: 'date', editable: false, nullable: true, visible: true },
    persIdentSysStartTimeUtc: { name: 'persIdentSysStartTimeUtc', type: 'date', editable: false, nullable: true, visible: true },
    persIdentSysEndTimeUtc: { name: 'persIdentSysEndTimeUtc', type: 'date', editable: false, nullable: true, visible: true },
}

export const publicOrderHistoryGridColumns = [
    {
        field: 'id',
        filterable: false,
        width: 100,
        hidden: true,
        lockable: false,
        locked: false,
        title: i18n.t('publicOrder.historyRecordsGridHeader.id'),
    },
    {
        field: 'nipCurrentNumber',
        width: 200,
        lockable: true,
        locked: false,
        title: i18n.t('publicOrder.historyRecordsGridHeader.nipCurrentNumber'),
    },
    {
        field: 'subject',
        width: 200,
        lockable: true,
        locked: false,
        title: i18n.t('publicOrder.historyRecordsGridHeader.subject'),
    },
    {
        field: 'publishDateUtc',
        width: 200,
        lockable: true,
        locked: false,
        format: '{0:dd.MM.yyyy}',
        title: i18n.t('publicOrder.historyRecordsGridHeader.publishDateUtc'),
    },
    {
        field: 'statusName',
        width: 200,
        lockable: true,
        locked: false,
        hidden: store.getters.isEnVersion,
        title: i18n.t('publicOrder.historyRecordsGridHeader.statusName'),
    },
    {
        field: 'statusNameEn',
        width: 200,
        lockable: true,
        locked: false,
        hidden: !store.getters.isEnVersion,
        title: i18n.t('publicOrder.historyRecordsGridHeader.statusName'),
    },
    {
        field: 'typeName',
        width: 150,
        lockable: true,
        locked: false,
        hidden: store.getters.isEnVersion,
        title: i18n.t('publicOrder.historyRecordsGridHeader.typeName'),
    },
    {
        field: 'typeNameEn',
        width: 150,
        lockable: true,
        locked: false,
        hidden: !store.getters.isEnVersion,
        title: i18n.t('publicOrder.historyRecordsGridHeader.typeName'),
    },
    {
        field: 'assignmentTypeName',
        width: 200,
        lockable: true,
        locked: false,
        hidden: store.getters.isEnVersion,
        title: i18n.t('publicOrder.historyRecordsGridHeader.assignmentTypeName'),
    },
    {
        field: 'assignmentTypeNameEn',
        width: 200,
        lockable: true,
        locked: false,
        hidden: !store.getters.isEnVersion,
        title: i18n.t('publicOrder.historyRecordsGridHeader.assignmentTypeName'),
    },
    {
        field: 'other1',
        width: 200,
        lockable: true,
        locked: false,
        title: i18n.t('publicOrder.historyRecordsGridHeader.other1'),
    },
    {
        field: 'other2',
        width: 200,
        lockable: true,
        locked: false,
        title: i18n.t('publicOrder.historyRecordsGridHeader.other2'),
    },
    {
        field: 'contactPersonId',
        width: 200,
        lockable: true,
        locked: false,
        title: i18n.t('publicOrder.historyRecordsGridHeader.contactPersonId'),
    },
    {
        field: 'description',
        width: 200,
        lockable: true,
        locked: false,
        title: i18n.t('publicOrder.historyRecordsGridHeader.description'),
    },
    {
        field: 'termDate',
        width: 200,
        lockable: true,
        locked: false,
        format: '{0:dd.MM.yyyy}',
        title: i18n.t('publicOrder.historyRecordsGridHeader.termDate'),
    },
    {
        field: 'objectTypeName',
        width: 200,
        lockable: true,
        locked: false,
        hidden: store.getters.isEnVersion,
        title: i18n.t('publicOrder.historyRecordsGridHeader.objectTypeName'),
    },
    {
        field: 'objectTypeNameEn',
        width: 200,
        lockable: true,
        locked: false,
        hidden: !store.getters.isEnVersion,
        title: i18n.t('publicOrder.historyRecordsGridHeader.objectTypeName'),
    },
    {
        field: 'referenceValue',
        width: 200,
        lockable: true,
        locked: false,
        title: i18n.t('publicOrder.historyRecordsGridHeader.referenceValue'),
    },
    {
        field: 'referenceValueCurrencyName',
        width: 200,
        lockable: true,
        locked: false,
        hidden: store.getters.isEnVersion,
        title: i18n.t('publicOrder.historyRecordsGridHeader.referenceValueCurrencyName'),
    },
    {
        field: 'referenceValueCurrencyNameEn',
        width: 200,
        lockable: true,
        locked: false,
        hidden: !store.getters.isEnVersion,
        title: i18n.t('publicOrder.historyRecordsGridHeader.referenceValueCurrencyName'),
    },
    {
        field: 'isOpen',
        width: 200,
        lockable: true,
        locked: false,
        title: i18n.t('publicOrder.historyRecordsGridHeader.isOpen'),
        template: function (dataItem) {
            return "<span>" + dataItem.isOpen === true ? i18n.t('yes') : i18n.t('no') + "</span>";
        }
    },
    {
        field: 'publicOrdersCurrentNumber',
        width: 200,
        lockable: true,
        locked: false,
        title: i18n.t('publicOrder.historyRecordsGridHeader.publicOrdersCurrentNumber'),
    },
    {
        field: 'referenceOrderId',
        width: 100,
        lockable: true,
        locked: false,
        title: i18n.t('publicOrder.historyRecordsGridHeader.referenceOrderId'),
    },
    {
        field: 'activityId',
        width: 100,
        lockable: true,
        locked: false,
        title: i18n.t('publicOrder.historyRecordsGridHeader.activityId'),
    },
    {
        field: 'deleted',
        width: 200,
        lockable: true,
        locked: false,
        title: i18n.t('publicOrder.historyRecordsGridHeader.deleted'),
        template: function (dataItem) {
            return "<span>" + dataItem.deleted === true ? i18n.t('yes') : i18n.t('no') + "</span>";
        }
    },
    {
        field: 'sysStartTimeUtc',
        width: 200,
        lockable: true,
        locked: false,
        format: '{0:dd.MM.yyyy HH:mm:ss}',
        title: i18n.t('publicOrder.historyRecordsGridHeader.sysStartTimeUtc'),
    },
    {
        field: 'sysEndTimeUtc',
        width: 200,
        lockable: true,
        locked: false,
        format: '{0:dd.MM.yyyy HH:mm:ss}',
        title: i18n.t('publicOrder.historyRecordsGridHeader.sysEndTimeUtc'),
    },
    {
        field: 'createdAtUtc',
        width: 200,
        lockable: true,
        locked: false,
        format: '{0:dd.MM.yyyy HH:mm:ss}',
        title: i18n.t('publicOrder.historyRecordsGridHeader.createdAtUtc'),
    },
    {
        field: 'creatorUsername',
        width: 200,
        lockable: true,
        locked: false,
        title: i18n.t('publicOrder.historyRecordsGridHeader.creatorUsername'),
    },
    {
        field: 'updatedAtUtc',
        width: 200,
        lockable: true,
        locked: false,
        format: '{0:dd.MM.yyyy HH:mm:ss}',
        title: i18n.t('publicOrder.historyRecordsGridHeader.updatedAtUtc'),
    },
    {
        field: 'updaterUsername',
        width: 200,
        lockable: true,
        locked: false,
        title: i18n.t('publicOrder.historyRecordsGridHeader.updaterUsername'),
    },
    {
        field: 'publicOrderSysStartTimeUtc',
        width: 200,
        lockable: true,
        locked: false,
        format: '{0:dd.MM.yyyy HH:mm:ss}',
        title: i18n.t('publicOrder.historyRecordsGridHeader.publicOrderSysStartTimeUtc'),
    },
    {
        field: 'publicOrderSysEndTimeUtc',
        width: 200,
        lockable: true,
        locked: false,
        format: '{0:dd.MM.yyyy HH:mm:ss}',
        title: i18n.t('publicOrder.historyRecordsGridHeader.publicOrderSysEndTimeUtc')
    }
]

export const publicOrderHistoryGridSchemaModelFields = {
    id: { name: 'id', type: 'number', editable: false, nullable: false, visible: true },
    nipCurrentNumber: { name: 'nipCurrentNumber', type: 'string', editable: false, nullable: true, visible: true },
    subject: { name: 'subject', type: 'string', editable: false, nullable: true, visible: true },
    publishDateUtc: { name: 'publishDateUtc', type: 'date', editable: false, nullable: true, visible: true },
    statusName: { name: 'statusName', type: 'string', editable: false, nullable: true, visible: !store.isEnVersion },
    statusNameEn: { name: 'statusNameEn', type: 'string', editable: false, nullable: true, visible: store.isEnVersion },
    typeName: { name: 'typeName', type: 'string', editable: false, nullable: true, visible: true },
    typeNameEn: { name: 'typeNameEn', type: 'string', editable: false, nullable: true, visible: true },
    assignmentTypeName: { name: 'assignmentTypeName', type: 'string', editable: false, nullable: true, visible: true },
    assignmentTypeNameEn: { name: 'assignmentTypeNameEn', type: 'string', editable: false, nullable: true, visible: true },
    other1: { name: 'other1', type: 'string', editable: false, nullable: true, visible: true },
    other2: { name: 'other2', type: 'string', editable: false, nullable: true, visible: true },
    contactPersonId: { name: 'contactPersonId', type: 'number', editable: false, nullable: true, visible: true },
    description: { name: 'description', type: 'string', editable: false, nullable: true, visible: true },
    termDate: { name: 'termDate', type: 'date', editable: false, nullable: true, visible: true },
    objectTypeName: { name: 'objectTypeName', type: 'string', editable: false, nullable: true, visible: true },
    objectTypeNameEn: { name: 'objectTypeNameEn', type: 'string', editable: false, nullable: true, visible: true },
    referenceValue: { name: 'referenceValue', type: 'number', editable: false, nullable: true, visible: true },
    referenceValueCurrencyName: { name: 'referenceValueCurrencyName', type: 'string', editable: false, nullable: true, visible: true },
    referenceValueCurrencyNameEn: { name: 'referenceValueCurrencyNameEn', type: 'string', editable: false, nullable: true, visible: true },
    isOpen: { name: 'isOpen', type: 'boolean', editable: false, nullable: true, visible: true },
    publicOrdersCurrentNumber: { name: 'publicOrdersCurrentNumber', type: 'string', editable: false, nullable: true, visible: true },
    referenceOrderId: { name: 'referenceOrderId', type: 'number', editable: false, nullable: true, visible: true },
    activityId: { name: 'activityId', type: 'number', editable: false, nullable: true, visible: true },
    deleted: { name: 'deleted', type: 'boolean', editable: false, nullable: true, visible: true },
    sysStartTimeUtc: { name: 'sysStartTimeUtc', type: 'date', editable: false, nullable: true, visible: true },
    sysEndTimeUtc: { name: 'sysEndTimeUtc', type: 'date', editable: false, nullable: true, visible: true },
    createdAtUtc: { name: 'createdAtUtc', type: 'date', editable: false, nullable: true, visible: true },
    createdBy: { name: 'createdBy', type: 'string', editable: false, nullable: true, visible: true },
    creatorUsername: { name: 'creatorUsername', type: 'string', editable: false, nullable: true, visible: true },
    updatedAtUtc: { name: 'updatedAtUtc', type: 'date', editable: false, nullable: true, visible: true },
    updatedBy: { name: 'updatedBy', type: 'string', editable: false, nullable: true, visible: true },
    updaterUsername: { name: 'updaterUsername', type: 'string', editable: false, nullable: true, visible: true },
    publicOrderSysStartTimeUtc: { name: 'publicOrderSysStartTimeUtc', type: 'date', editable: false, nullable: true, visible: true },
    publicOrderSysEndTimeUtc: { name: 'publicOrderSysEndTimeUtc', type: 'date', editable: false, nullable: true, visible: true }
}

export const externalSupplierHistoryGridColumns = [
    {
        field: 'id',
        filterable: false,
        width: 100,
        hidden: true,
        lockable: false,
        locked: false,
        title: i18n.t('externalSupplier.historyRecordsGridHeader.id'),
    },
    {
        field: 'companyName',
        width: 200,
        lockable: true,
        locked: false,
        hidden: store.getters.isEnVersion,
        title: i18n.t('externalSupplier.historyRecordsGridHeader.companyName'),
    },
    {
        field: 'companyNameEn',
        width: 200,
        lockable: true,
        locked: false,
        hidden: !store.getters.isEnVersion,
        title: i18n.t('externalSupplier.historyRecordsGridHeader.companyName'),
    },
    {
        field: 'deactivated',
        width: 200,
        lockable: true,
        locked: false,
        title: i18n.t('externalSupplier.historyRecordsGridHeader.deactivated'),
        template: function (dataItem) {
            return "<span>" + dataItem.deactivated === true ? i18n.t('yes') : i18n.t('no') + "</span>";
        }
    },
    {
        field: 'other1',
        width: 200,
        lockable: true,
        locked: false,
        title: i18n.t('externalSupplier.historyRecordsGridHeader.other1'),
    },
    {
        field: 'other2',
        width: 200,
        lockable: true,
        locked: false,
        title: i18n.t('externalSupplier.historyRecordsGridHeader.other2'),
    },
    {
        field: 'deleted',
        width: 200,
        lockable: true,
        locked: false,
        title: i18n.t('externalSupplier.historyRecordsGridHeader.deleted'),
        template: function (dataItem) {
            return "<span>" + dataItem.deleted === true ? i18n.t('yes') : i18n.t('no') + "</span>";
        }
    },
    {
        field: 'personFullName',
        width: 200,
        lockable: true,
        locked: false,
        hidden: store.getters.isEnVersion,
        title: i18n.t('externalSupplier.historyRecordsGridHeader.personFullName'),
    },
    {
        field: 'personFullNameEn',
        width: 200,
        lockable: true,
        locked: false,
        hidden: !store.getters.isEnVersion,
        title: i18n.t('externalSupplier.historyRecordsGridHeader.personFullName'),
    },
    {
        field: 'isCompany',
        width: 200,
        lockable: true,
        locked: false,
        title: i18n.t('externalSupplier.historyRecordsGridHeader.isCompany'),
        template: function (dataItem) {
            return "<span>" + dataItem.isCompany === true ? i18n.t('yes') : i18n.t('no') + "</span>";
        }
    },
    {
        field: 'externalSupplierSysStartTimeUtc',
        width: 200,
        lockable: true,
        locked: false,
        hidden: false,
        format: '{0: dd-MM-yyyy HH:mm:ss}',
        title: i18n.t('externalSupplier.historyRecordsGridHeader.externalSupplierSysStartTimeUtc'),
    },
    {
        field: 'externalSupplierSysEndTimeUtc',
        width: 200,
        lockable: true,
        locked: false,
        hidden: false,
        format: '{0: dd-MM-yyyy HH:mm:ss}',
        title: i18n.t('externalSupplier.historyRecordsGridHeader.externalSupplierSysEndTimeUtc'),
    },
]

export const externalSupplierHistoryGridSchemaModelFields = {
    id: { name: 'id', type: 'number', editable: false, nullable: false, visible: true },
    companyName: { name: 'companyName', type: 'string', editable: false, nullable: true, visible: true },
    companyNameEn: { name: 'companyNameEn', type: 'string', editable: false, nullable: true, visible: true },
    deactivated: { name: 'deactivated', type: 'boolean', editable: false, nullable: false, visible: true },
    other1: { name: 'other1', type: 'string', editable: false, nullable: true, visible: true },
    other2: { name: 'other2', type: 'string', editable: false, nullable: true, visible: true },
    deleted: { name: 'deleted', type: 'boolean', editable: false, nullable: false, visible: true },
    personId: { name: 'personId', type: 'number', editable: false, nullable: true, visible: true },
    personFullName: { name: 'personFullName', type: 'string', editable: false, nullable: true, visible: true },
    personFullNameEn: { name: 'personFullNameEn', type: 'string', editable: false, nullable: true, visible: true },
    isCompany: { name: 'isCompany', type: 'boolean', editable: false, nullable: false, visible: true },
    externalSupplierSysStartTimeUtc: { name: 'externalSupplierSysStartTimeUtc', type: 'date', editable: false, nullable: true, visible: true },
    externalSupplierSysEndTimeUtc: { name: 'externalSupplierSysEndTimeUtc', type: 'date', editable: false, nullable: true, visible: true },
}


export default {
    personHistoryGridColumns,
    personHistoryGridSchemaModelFields,
    publicOrderHistoryGridColumns,
    publicOrderHistoryGridSchemaModelFields,
    externalSupplierHistoryGridColumns,
    externalSupplierHistoryGridSchemaModelFields
}
